import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  toggled = false;
  _hasBackgroundImage = true;
  default_menu = [
      {
        title: 'Dashboard',
        access: ['HOME'],
          active: true,
          iconclass: 'fa fa-desktop',
          link: '/elasticcare/dashboard',
          type: 'simple'
      },
    /*  {
        title: 'Package',
        access: ['ALL_PACKAGE', 'REMOVE_PACKAGE'],
        iconclass: 'fa fa-archive',
        active: false,
        link: '/elasticcare/package',
        type: 'simple'
      },*/
   /* {
      title: 'Inventory',
      access: ['MAIN_MENU_INVENTORY'],
      iconclass: 'fa fa-archive',
      active: false,
      link: '/elasticcare/clientinventory',
      type: 'simple'
    },*/
  /*  {
      title: 'Client',
      access: ['ALL_CLIENTS'],
      iconclass: 'fa fa-user-md',
      active: false,
      link: '/elasticcare/client',
      type: 'simple'
    },*/
    {
      title: 'Patient',
      access: ['MAIN_MENU_PATIENTS'],
      iconclass: 'fa fa-wheelchair',
      active: false,
      link: '/elasticcare/patient',
      type: 'simple'
    },
    {
    title: 'Physician',
    access: ['MAIN_MENU_PATIENTS'],
    iconclass: 'fa fa-stethoscope',
    active: false,
    link: '/elasticcare/physician',
    type: 'simple'
  },
 /*   {
      title: 'My Team',
      access: ['MAIN_MENU_MY_TEAM'],
      iconclass: 'fa fa-users',
      active: false,
      link: '/elasticcare/clientcontacts',
      type: 'simple'
    },*/
     /* {
        title: 'Orders',
        access: ['ALL_ORDERS'],
        iconclass: 'fa fa-first-order',
        active: false,
        link: '/elasticcare/order',
        type: 'simple'
      },*/
    {
      title: 'Users',
      access: ['ALL_USERS'],
      iconclass: 'fa fa-users',
      active: false,
      link: '/elasticcare/user',
      type: 'simple'
    },
    {
      title: 'Transaction',
      access: ['ALL_USERS'],
      iconclass: 'fa fa-retweet',
      active: false,
      link: '/elasticcare/transaction',
      type: 'simple'
    },
    {
      title: 'Appointments',
      access: ['ALL_USERS'],
      iconclass: 'fa fa-calendar-check-o',
      active: false,
      link: '/elasticcare/appointments',
      type: 'simple'
    },
      {
      title: 'Physician Commission',
      access: ['ALL_USERS'],
      iconclass: 'fa fa-money',
      active: false,
      link: '/elasticcare/commission',
      type: 'simple'
    },
      {
      title: 'Physician Commets',
      access: ['ALL_USERS'],
      iconclass: 'fa fa-comment',
      active: false,
      link: '/elasticcare/comment',
      type: 'simple'
    },
    /*{
      title: 'Auth Certificate',
      access: ['AUTHENTICATION_VIEW'],
      iconclass: 'fa fa-key',
      active: false,
      link: '/elasticcare/authentications',
      type: 'simple'
    },
    {
      title: 'Firmware Setup',
      access: ['GET_FIRMWARE'],
      iconclass: 'fa fa-gear',
      active: false,
      link: '/elasticcare/firmware',
      type: 'simple'
    },
    {
      title: 'Filters',
      access: ['GET_FIRMWARE'],
      iconclass: 'fa fa-filter',
      active: false,
      link: '/elasticcare/filter',
      type: 'simple'
    },
    {
      title: 'Report',
      access: ['ALL_REPORTS'],
      iconclass: 'fa fa-bar-chart-o',
      active: false,
      link: '/elasticcare/report',
      type: 'simple'
    },
    {
      title: 'Thresholds Setting',
      access: ['USER_ALGORITHM_CONFIG_VIEW', 'SYSTEM_ALGORITHM_CONFIG'],
      iconclass: 'fa fa-bolt',
      active: false,
      link: '/elasticcare/algorithm',
      type: 'simple'
    }*/
  ];
  constructor() { }

  toggle() {
    this.toggled = ! this.toggled;
  }

  getSidebarState() {
    return this.toggled;
  }

  setSidebarState(state: boolean) {
    this.toggled = state;
  }
/*
  getMenuList() {
    return this.menus;
  }*/

  getDefaultMenuList() {
    return this.default_menu;
  }

  get hasBackgroundImage() {
    return this._hasBackgroundImage;
  }

  set hasBackgroundImage(hasBackgroundImage) {
    this._hasBackgroundImage = hasBackgroundImage;
  }
}
